(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/views/odds-slider/matchen-odds-switch.js') >= 0) return;  svs.modules.push('/modules/matchen/views/odds-slider/matchen-odds-switch.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.matchen=_svs.matchen||{};
_svs.matchen.templates=_svs.matchen.templates||{};
svs.matchen.templates.matchen_odds_switch = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = (lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||alias2).call(alias1,"form/radio-button",{"name":"ui","hash":{"value":"my-odds","checked":true,"class":"js-odds-switch form-toggle-matchen","name":"toggle-radio-group3[]"},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":3,"column":152}}})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = (lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||alias2).call(alias1,"form/radio-button",{"name":"ui","hash":{"value":"least-most","class":"js-odds-switch form-toggle-matchen","name":"toggle-radio-group3[]"},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":4,"column":151}}})) != null ? stack1 : "")
    + "\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "Mina odds";
},"4":function(container,depth0,helpers,partials,data) {
    return "Mest/minst spelade";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"grid-row margin-bottom-1\">\n"
    + ((stack1 = (lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form/radio-group",{"name":"ui","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":5,"column":11}}})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});
Handlebars.partials['svs-matchen-matchen_odds_switch'] = svs.matchen.templates.matchen_odds_switch;
})(svs, Handlebars);


 })(window);